import { apiSlice } from "../api/apiSlice";

export const analyticsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReliabilitySummary: builder.query({
      query: () => "/analytics/reliability-summary/",
      providesTags: ["reliability_summary"],
    }),
    
    getReliabilityData: builder.query({
      query: (summaryId) => `/analytics/reliability-summary/${summaryId}/`,
      providesTags: (result, error, summaryId) => [
        { type: "reliability_data", id: summaryId },
      ],
    }),
  }),
});

export const {
  useGetReliabilitySummaryQuery,
  useGetReliabilityDataQuery,
} = analyticsApiSlice;